import React from "react";
import { Box, VStack, Text, Button, Flex, Menu, MenuButton } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { useDisclosure } from "@chakra-ui/react";
import { Store, BarChart2, Bell, Users, Settings, HelpCircle, LogOut, Shield } from "lucide-react";
import { UnsubscribeModal } from "./UnsubscribeModal";
import { useDispatch } from "react-redux";
import { logout } from '@state/userSlice/userSlice';
import type { AppDispatch } from "@state/store";
import { useSelector } from "react-redux";
import { selectUserState } from "@state/userSlice/userSlice";
import { roles } from "@hz/stealthy-gmc-cloaker-common/constants";

export const Sidebar = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { userRole } = useSelector(selectUserState);
  const location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleLogout = () => {
    dispatch(logout());
  };

  const NavButton = ({
    icon,
    children,
    to,
  }: {
    icon: React.ReactNode;
    children: React.ReactNode;
    to: string;
  }) => (
    <Button
      as={Link}
      to={to}
      leftIcon={icon as any}
      variant="ghost"
      justifyContent="flex-start"
      w="full"
      color={location.pathname === to ? "white" : "gray.300"}
      bg={location.pathname === to ? "gray.700" : "transparent"}
      _hover={{
        bg: "gray.700",
        color: "white",
      }}
    >
      {children}
    </Button>
  );

  return (
    <Box
      w="250px"
      h="100vh"
      bg="gray.800"
      p={4}
      position="fixed"
      left={0}
      top={0}
      borderRight="1px"
      borderColor="gray.700"
    >
      <VStack h="full" align="stretch" spacing={8}>
        <Text
          fontSize="xl"
          fontFamily="mono"
          fontWeight="bold"
          color="#ff3d00"
          p={2}
        >
          StealthyGMC
        </Text>

        <VStack align="stretch" spacing={2}>
          {/* Only show for roles other than STANDARD */}
          {userRole !== roles.STANDARD && (
            <NavButton icon={<Store size={20} />} to="/">
              Stores
            </NavButton>
          )}

          {/* Always show Whitelist */}
          <NavButton icon={<Shield size={20} />} to="/whitelist">
            Whitelist IPs
          </NavButton>

          {/* Only show Users tab if not STANDARD */}
          {userRole !== roles.STANDARD && (
            <NavButton icon={<Users size={20} />} to="/users">
              Users
            </NavButton>
          )}
        </VStack>

        <Flex flex={1} />

        <Menu>
          <MenuButton
            as={Button}
            leftIcon={<LogOut size={20} />}
            variant="ghost"
            w="full"
            onClick={handleLogout}
            justifyContent="flex-start"
            color="gray.300"
            _hover={{
              bg: "gray.700",
              color: "white",
            }}
          >
            Logout
          </MenuButton>
        </Menu>
      </VStack>

      <UnsubscribeModal isOpen={isOpen} onClose={onClose} />
    </Box>
  );
};
